import { render, staticRenderFns } from "./hdr-card.vue?vue&type=template&id=3408067b&scoped=true&"
import script from "./hdr-card.vue?vue&type=script&lang=js&"
export * from "./hdr-card.vue?vue&type=script&lang=js&"
import style0 from "./hdr-card.vue?vue&type=style&index=0&id=3408067b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408067b",
  null
  
)

export default component.exports